import { getLoggedinUser, getUser } from "../userStore";
import moment from "moment";
import { Icon } from "./icons";

export function parseResponse(res) {
  var response = null,
    data = null,
    meta = null,
    msg = "",
    code = -1;
  if (res.response) {
    response = res.response;
  } else if (res.data && res.data.response) {
    response = res.data.response;
  } else if (res.data && res.data.data) {
    response = res.data;
  } else if (res.isSuccess && res.data) {
    response = res;
    response.code = 0;
  }
  code = response?.code;
  msg = response?.msg || "";
  if (response?.code == 0 && response?.data) {
    data = response?.data || null;
    meta = response?.meta || null;
  }
  return { data, meta, msg, code };
}

export const isFullLayout = () => {
  return window.location.pathname === "/login"
    ? true
    : window.location.pathname === "/create-pin";
};

export const getFileUrl = (uuid) => {
  let url = "";
  url += getBaseUrl() + "/notes/get_attachment.json";
  url += "?uuid=" + uuid || "";
  url += "&tz=" + String(new Date().getTimezoneOffset());
  return url;
};

export const getAttachmentURL = (
  id,
  file_type = "image",
  width = null,
  height = null
) => {
  const user = getLoggedinUser();
  const resourceUrl = "/messages/get_attachment";
  const url = getBaseUrl() + resourceUrl;

  let fileUrl = url + "/" + id + "?" + getGlobalParams();

  if (file_type == "image")
    fileUrl +=
      "&" + "thumbnail=" + (width || "") + (height ? "x" + height : "");

  return fileUrl + "&" + new Date().getTime();
};

export const copyDeepObjects = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export const formattedDatePp = (date, format = "MM/DD/YYYY") => {
  // "YYYY-MM-DD"
  if (!date) {
    return "";
  }
  const momentDate = moment(date).format(format);
  return moment(momentDate).isValid() ? momentDate : "";
};

export const getUserPictureUrl = (
  id,
  role = "patient",
  width = 200,
  height = 200
) => {
  let resourceUrl = "/messages/get_attachment/" + role,
    url = getBaseUrl() + resourceUrl;
  let fileUrl = "";
  fileUrl +=
    url +
    "?" +
    getGlobalParams("tz,token") +
    "&thumbnail=" +
    width +
    "x" +
    height;
  if (role == "patient" || role == "provider") {
    fileUrl += "&pid=" + id;
  } else {
    fileUrl += "&id=" + id;
  }
  return fileUrl;
};

export function capitalizeFirstLetter(string) {
  if (typeof string !== "string" || string.length === 0) {
    return string;
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export const LoadingData = ({ msg }) => {
  return (
    <div className="p-4 text-center text-lg text-slate-400">
      {msg || "Loading..."} <Icon color="text-slate-400" type="inline-loader" />
    </div>
  );
};

export const timeDifference = (dateCreated) => {
  const today = moment(new Date());
  const created = moment(new Date(dateCreated));
  const years = today.diff(created, "years");
  if (years > 0) {
    return Math.floor(years) + " yr";
  }
  const months = today.diff(created, "months");
  if (months > 0) {
    return Math.floor(months) + " m";
  }
  const days = today.diff(created, "days");
  if (days > 0) {
    return Math.floor(days) + " d";
  }
  const hrs = today.diff(created, "hours");
  if (hrs > 0) {
    return Math.floor(hrs) + " hrs";
  }
  const mins = today.diff(created, "minutes");
  if (mins > 0) {
    return Math.floor(mins) + " mins";
  }
  const secs = today.diff(created, "seconds");
  if (secs > 0) {
    return Math.floor(secs) + " s";
  }
  return false;
};

export const getGlobalParams = (keys = "token,tz,practice_id") => {
  let paramStr = "";
  const sessionUser = getLoggedinUser();
  if (keys.includes("token")) {
    paramStr += "token=" + sessionUser.token;
  }
  if (keys.includes("practice_id")) {
    paramStr += "&practice_id=" + sessionUser.practice_id;
  }
  if (keys.includes("tz")) {
    paramStr += "&tz=" + String(new Date().getTimezoneOffset());
  }
  return paramStr;
};

export const ProgressBarPp = ({ progress }) => {
  return (
    <div className="w-9/12 bg-gray-200 rounded-full h-1.5 dark:bg-gray-700 border">
      <div
        className="bg-indigo-600 h-1.5 rounded-full dark:bg-indigo-500"
        style={{ width: (progress || 0) + "%" }}></div>
    </div>
  );
};

// Helper function to parse time string into a Date object
function parseTime(timeString) {
  const [hours = "", minutes = "", seconds = ""] = timeString
    ?.split(":")
    ?.map(Number);
  const date = new Date();
  date.setHours(hours, minutes, seconds, 0);
  return date;
}

// Helper function to format Date object back to time string
function formatTime(date) {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

// Function to create time slots
// export function createTimeSlots(fromTime, toTime, intervalMinutes) {
//   const startDate = fromTime ? parseTime(fromTime) : null;
//   const endDate = toTime ? parseTime(toTime) : null;
//   const slots = [];

//   if (!startDate || !endDate) return slots;
//   let currentSlot = new Date(startDate);

//   while (currentSlot < endDate) {
//     const nextSlot = new Date(currentSlot.getTime() + intervalMinutes * 60000);
//     slots.push({
//       start: formatTime(currentSlot),
//       end: formatTime(nextSlot),
//     });
//     currentSlot = nextSlot;
//   }

//   return slots;
// }

export function createTimeSlots(
  fromTime,
  toTime,
  intervalMinutes,
  blockTimes,
  calender_id
) {
  const startDate = fromTime ? parseTime(fromTime) : null;
  const endDate = toTime ? parseTime(toTime) : null;
  const slots = [];
  if (!startDate || !endDate) return slots;

  let currentSlot = new Date(startDate);

  while (currentSlot < endDate) {
    const nextSlot = new Date(currentSlot.getTime() + intervalMinutes * 60000);

    const slot = {
      start: formatTime(currentSlot),
      end: formatTime(nextSlot),
      calender_id: calender_id,
    };

    // Check if the slot is within any of the block time ranges
    for (const block of blockTimes) {
      const blockStart = block?.from_time ? parseTime(block?.from_time) : null;
      const blockEnd = block?.to_time ? parseTime(block?.to_time) : null;
      if (!blockStart || !blockEnd) continue;
      if (currentSlot >= blockStart && currentSlot <= blockEnd) {
        slot.block = true;
        slot.reason = block?.title;
        break;
      }
    }

    slots.push(slot);
    currentSlot = nextSlot;
  }

  return slots;
}

export function getGlobalSetting() {
  return process.env.REACT_APP_SETTINGS;
}

export const BtnComponent = ({
  btnType = "default",
  type = "button",
  text = "",
  btnRef = null,
  size = "md",
  className = "",
  loading = false,
  ...btnProps
}) => {
  const defaultCss = "border rounded";
  let sizeCss = "py-1 px-2.5";
  if (size == "md") {
    sizeCss = "pr-2.5 pl-2 py-1";
  } else if (size == "sm") {
    sizeCss = "text-sm px-2 py-0.5";
  } else if (size == "xs") {
    sizeCss = "text-xs px-1 py-0.5";
  } else if (size == "tiny") {
    sizeCss = "text-xs p-0";
  }

  const typeCss = {
    delete:
      "py-1 px-2.5 font-normal rounded text-[14px] text-danger-hover border-danger-hover border hover:bg-danger-hover hover:text-white",
    cancel:
      "py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border hover:bg-gray-e5 hover:text-black-300",
    blue: "text-white bg-blue-400 hover:bg-blue-500 dark:bg-blue-500 dark:hover:bg-blue-500 border-blue-400",
    primary:
      " font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover",
    cyan: "text-white bg-cyan-600 hover:bg-cyan-800 border-cyan-500",
    chief: "text-white bg-[#b17474] hover:bg-[#8c5c5c] border-[#b17474]",
    default: "bg-white hover:bg-gray-100 text-gray-500 border-gray-400",
    danger:
      "font-normal rounded text-[14px] text-white border-amber-600 border bg-amber-600 hover:bg-amber-700",
    success:
      "font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover",
    remove:
      "text-orange-700 bg-white hover:bg-amber-100 border-stone-300 p-0.1",
  };

  return (
    <>
      <button
        ref={btnRef}
        type={type}
        {...btnProps}
        className={`${
          btnProps.disabled && "opacity-50 cursor-not-allowed"
        } ${className} ${defaultCss} ${typeCss[btnType]} ${sizeCss}`}>
        {btnType == "remove" ? <Icon type="cross" /> : text}{" "}
        {loading ? <Icon type="inline-loader" /> : ""}
      </button>
    </>
  );
};
export const getBaseUrl = () => {
  // let checkPractice = localStorage.getItem("organization_code");
  // let organization_config = localStorage.getItem("organization_config");
  // //if checkPractice match the name key in organization_config then return the api_url

  // let organization_config_obj = JSON.parse(organization_config);
  // let checkPracticeObj = organization_config_obj.find((item) =>
  //   item?.short_code?.toLowerCase()?.includes(checkPractice?.toLowerCase())
  // );

  // if (checkPracticeObj?.api_url) {
  //   return checkPracticeObj?.api_url;
  // } else {
  //   return process.env.REACT_APP_API_URL_V1;
  // }
  let baseUrl = "";
  let server_api = JSON.parse(localStorage.getItem("baseUrl"));
  if (server_api) {
    baseUrl = server_api;
  } else {
    baseUrl = process.env.REACT_APP_API_URL_V1;
  }
  return baseUrl;
};
